<template>
  <div>
    <v-snackbar v-model="showSnackBar" :color="snackBarColor" left :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <div style="background-color: #f9fafb; min-height: 100vh; padding-bottom: 40px;" v-if="!appLoading && sellerData">
    <div style="padding-top: 10px;" class="px-4 px-md-6 px-lg-8">
      <v-layout wrap class="mx-n3">
        <!-- Top Section: Seller Profile & About Us -->
        <v-flex xs12 class="px-3 pt-3 pb-2">
          <v-card flat class="pa-4 pa-md-6" style="border-radius: 20px; box-shadow: 0 4px 20px rgba(0,0,0,0.04) !important;">
            <!-- Modern Back Button -->
            <!-- <div class="d-flex align-center mb-4 mb-md-6">
              <v-btn 
                depressed
                class="rounded-lg px-4"
                style="background-color: #f8fafc; color: #475467; text-transform: none; font-family: 'ibmmedium', sans-serif; font-size: 14px; font-weight: 500; height: 40px; border: 1px solid #e2e8f0; letter-spacing: 0;"
                @click="$router.go(-1)"
              >
                <v-icon left size="18" color="#64748b" class="mr-1">mdi-arrow-left</v-icon>
                Go Back
              </v-btn>
            </div> -->
            <v-layout wrap align-center>
              <!-- Avatar -->
              <v-flex xs12 md2 class="text-center text-md-center mb-4 mb-md-0 d-flex justify-center">
                <div style="position: relative; display: inline-block;">
                  <v-avatar size="130" style="background-color: #F0FDF4; border: 4px solid #fff; box-shadow: 0 4px 12px rgba(0,0,0,0.05);">
                    <img v-if="sellerData.image" :src="mediaURLOld + sellerData.image" style="width: 100%; height: 100%; object-fit: cover;" />
                    <img v-else-if="sellerData.seller && sellerData.seller.coverimage" :src="mediaURLOld + sellerData.seller.coverimage" style="width: 100%; height: 100%; object-fit: cover;" />
                    <v-icon v-else size="65" color="#059669">mdi-store</v-icon>
                  </v-avatar>
                  <!-- <v-icon color="#059669" size="30" style="position: absolute; bottom: 8px; right: 0px; background: white; border-radius: 50%;">mdi-check-circle</v-icon> -->
                </div>
              </v-flex>

              <!-- Basic Details -->
              <v-flex xs12 md4 class="text-center text-md-left mb-4 mb-md-0 px-md-4" style="border-right: 1px solid #E2E8F0;" v-if="sellerData">
                <div class="d-flex align-center justify-center justify-md-start mb-2">
                  <h2 style="font-family: 'ibmsemibold', sans-serif; font-size: 30px; color: #0F172A; text-transform: uppercase;" class="mr-2">
                    {{ sellerData.organization ? sellerData.organization : (sellerData.firstname + (sellerData.lastname ? ' ' + sellerData.lastname : '')) }}
                  </h2>
                </div>
                <div class="d-flex align-center justify-center justify-md-start mb-4" style="font-family: 'ibmregular', sans-serif; font-size: 14px;">
                  <v-rating 
                    v-if="sellerData.seller" 
                    v-model="sellerData.seller.rating" 
                    background-color="yellow" 
                    color="yellow" 
                    small 
                    readonly 
                    half-increments
                    dense
                    class="mr-1">
                  </v-rating>
                  <template v-if="sellerData.seller && sellerData.seller.rating > 0">
                    <span style="font-family: 'ibmsemibold', sans-serif; color: #101828; font-size: 15px;" class="mr-2">{{ sellerData.seller.rating }}</span>
                    <!-- <span style="color: #EAECF0;">|</span>
                    <span class="ml-2" style="color: #667085;">{{ sellerData.seller.viewcount || 0 }} Reviews</span> -->
                  </template>
                </div>
                <div class="d-flex flex-wrap align-center justify-center justify-md-start" style="font-family: 'ibmregular', sans-serif; font-size: 14px; color: #475467; gap: 16px;">
                  <div class="d-flex align-center" v-if="sellerData.billingaddress && sellerData.billingaddress.length > 0">
                    <v-icon color="#10B981" class="mr-2" size="20">mdi-map-marker</v-icon>
                    <span>{{ sellerData.billingaddress[0].city }}, {{ sellerData.billingaddress[0].state }}</span>
                  </div>
                  <div style="width: 1px; height: 16px; background-color: #CBD5E1;" class="hidden-sm-and-down" v-if="sellerData.billingaddress && sellerData.billingaddress.length > 0"></div>
                  <div class="d-flex align-center" v-if="sellerData.account_create_at">
                    <v-icon color="#10B981" class="mr-2" size="20">mdi-calendar-blank</v-icon>
                    <span>Joined {{ formatDate(sellerData.account_create_at) }}</span>
                  </div>
                </div>
              </v-flex>

              <!-- About Us -->
              <v-flex xs12 md6 class="px-md-8 text-center text-md-left" v-if="sellerData">
                <h3 style="font-family: 'ibmsemibold', sans-serif; font-size: 22px; color: #065F46;" class="mb-3">About Us</h3>
                <div class="d-flex align-start text-left">
                  <span style="font-size: 55px; color: #86EFAC; line-height: 0.8; font-family: serif; margin-right: 8px; margin-top: 10px;">&ldquo;</span>
                  <p style="font-family: 'ibmregular', sans-serif; font-size: 15px; color: #334155; line-height: 1.6;" class="mb-0 pt-2">
                    {{ sellerData.seller && sellerData.seller.about ? sellerData.seller.about : 'We are committed to providing high-quality products with exceptional customer service. Our focus is on delivering reliable, value-driven solutions that meet the needs of our customers while maintaining the highest standards of quality, trust, and satisfaction. We strive to build long-term relationships through transparency, consistency, and a customer-first approach.' }}
                  </p>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>

        <!-- Search & Categories Section -->
        <v-flex xs12 class="px-3 pt-2 pb-0">
          <div style="background-color: #ffffff; border-radius: 20px; box-shadow: 0 4px 20px rgba(0,0,0,0.04); padding: 16px 24px;">
            <v-layout wrap align-center justify-space-between class="mb-2">
              <!-- Search Bar -->
              <v-flex xs12 md4 class="mb-2 mb-md-0">
                <v-text-field
                  v-model="searchQuery"
                  outlined
                  dense
                  hide-details
                  clearable
                  placeholder="Search products in this store..."
                  prepend-inner-icon="mdi-magnify"
                  color="#10B981"
                  class="search-input"
                  @keyup.enter="onSearch"
                  @click:clear="onSearch"
                >
                  <template v-slot:append>
                    <v-btn color="#10B981" dark small class="rounded-lg ml-2 px-6" style="text-transform: none; font-weight: 600; height: 36px; margin-top: -2px;" @click="onSearch">
                      Search
                    </v-btn>
                  </template>
                </v-text-field>
              </v-flex>
              
              <!-- Categories (Chips) -->
              <v-flex xs12 md8 class="pl-md-4" v-if="category && category.length > 0">
                 <v-chip-group show-arrows center-active style="max-width: 100%;">
                   <v-chip
                     :color="!selectedCategoryId ? '#3EA56E' : '#ffffff'" 
                     :text-color="!selectedCategoryId ? '#ffffff' : '#3EA56E'"
                     :style="!selectedCategoryId ? 'border: 1px solid #3EA56E; height: 32px; border-radius: 16px;' : 'border: 1px solid #e2e8f0; height: 32px; border-radius: 16px;'"
                     class="font-weight-bold px-4"
                     @click="filterByCategory(null)"
                   >
                     All
                   </v-chip>
                   <v-chip
                     v-for="(item, i) in category" :key="i"
                     :color="selectedCategoryId === item._id ? '#3EA56E' : '#ffffff'" 
                     :text-color="selectedCategoryId === item._id ? '#ffffff' : '#3EA56E'"
                     :style="selectedCategoryId === item._id ? 'border: 1px solid #3EA56E; height: 32px; border-radius: 16px;' : 'border: 1px solid #e2e8f0; height: 32px; border-radius: 16px;'"
                     class="font-weight-bold px-4"
                     @click="filterByCategory(item)"
                   >
                     {{ item.name }}
                   </v-chip>
                 </v-chip-group>
              </v-flex>
            </v-layout>
            
            <!-- Subcategories (Circular Slider) -->
            <v-layout wrap v-if="filteredSubcategory && filteredSubcategory.length > 0">
              <v-flex xs12>
                 <v-sheet class="pt-2 px-1" style="background-color: transparent;">
                   <v-layout align-center justify-center>
                     <v-flex>
                        <OwlCarousel :key="selectedCategoryId || 'all'" :nav="false" :dots="true" :responsive="{ 0: { items: 3 }, 600: { items: 5 }, 960: { items: 6 }, 1264: { items: 8 } }" class="subcategory-carousel mt-1">
                         <template v-for="(item, i) in filteredSubcategory">
                           <v-flex px-1 :key="i">
                             <v-layout wrap justify-center style="position: relative; margin-bottom: 12px; cursor: pointer;" class="category-item" @click="filterBySubcategory(item)">
                               <v-flex xs12 class="d-flex justify-center" style="position: relative;">
                                 <div style="position: relative; display: inline-block;">
                                   <div 
                                     class="category-ring"
                                     :style="selectedSubcategoryId === item._id ? 'border-color: #3EA56E;' : 'border-color: #e2e8f0;'"
                                     style="border-style: solid; border-width: 2px; border-radius: 50%; padding: 2px; width: 70px; height: 70px; display: flex; align-items: center; justify-content: center; background-color: #ffffff; transition: all 0.3s ease;">
                                     <v-avatar size="62" style="background-color: #f8fafc;">
                                       <v-img cover :src="mediaURLOld + item.icon">
                                       </v-img>
                                     </v-avatar>
                                   </div>
                                 </div>
                               </v-flex>
                               <v-flex xs12 class="text-center mt-3 px-2">
                                 <span 
                                   :style="selectedSubcategoryId === item._id ? 'color: #3EA56E;' : 'color: #1e293b;'"
                                   style="font-family: 'Poppins', sans-serif; font-weight: 700; font-size: 10px; text-transform: uppercase; display: block; line-height: 1.4; transition: color 0.3s ease;">
                                   {{ item.name }}
                                 </span>
                               </v-flex>
                             </v-layout>
                           </v-flex>
                         </template>
                       </OwlCarousel>
                     </v-flex>
                   </v-layout>
                 </v-sheet>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
        
        <!-- Products Listing Section -->
        <v-flex xs12 class="px-3 pt-4 pb-3">
          <div class="d-flex align-center justify-space-between mb-5 px-1">
            <div class="d-flex align-center">
              <div style="width: 4px; height: 28px; background: linear-gradient(135deg, #10B981 0%, #059669 100%); border-radius: 4px; margin-right: 14px; box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);"></div>
              <h3 style="font-family: 'ibmsemibold', sans-serif; font-size: 24px; color: #0F172A; margin: 0; letter-spacing: -0.5px;">All Products</h3>
            </div>
          </div>
          <v-layout wrap class="mx-n2" v-if="products.length > 0">
            <v-flex xs12 sm6 md4 lg3 xl2 pa-2 v-for="(item, i) in products" :key="i">
              <v-hover v-slot="{ hover }">
                <v-card
                  class="premium-product-card mx-auto"
                  :elevation="hover ? 12 : 0"
                  @click="changeRoute(item)"
                  style="transition:all .3s ease; border-radius: 16px; border: 1px solid #f1f5f9; overflow: hidden; display: flex; flex-direction: column; height: 100%; cursor: pointer;"
                >
                  <!-- Image Section -->
                  <div style="position: relative; background: white; padding: 16px; display: flex; justify-content: center; align-items: center; border-radius: 16px 16px 0 0; overflow: hidden;">
                    <!-- Stock Status -->
                    <div style="position: absolute; top: 12px; left: 12px; z-index: 2; display: flex; flex-direction: column; gap: 6px;">
                      <div v-if="item.status == 'Inactive' || item.quantity < item.minimumOrderQuantity" style="background: #fee2e2; color: #ef4444; font-size: 10px; font-weight: 700; padding: 4px 10px; border-radius: 6px; text-transform: uppercase;">
                        Out of Stock
                      </div>
                    </div>
                    
                    <v-img
                      v-if="item.photos && item.photos.length > 0"
                      :src="mediaURLOld + item.photos[0]"
                      height="200"
                      contain
                      class="product-visual"
                      style="transition: transform 0.5s ease;"
                    >
                      <template v-slot:placeholder>
                        <div class="img-shimmer"></div>
                      </template>
                    </v-img>
                    <v-img
                      v-else
                      src="./../../../assets/Images/noimage.png"
                      height="200"
                      contain
                      class="product-visual"
                    ></v-img>
                  </div>

                  <!-- Info Section -->
                  <v-card-text class="pa-4 text-left d-flex flex-column" style="flex-grow: 1;">
                    <!-- Title -->
                    <h3 style="font-size: 16px; font-weight: 700; color: #1e293b; margin-bottom: 4px; line-height: 1.4; height: 39px; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;">
                      {{ item.productname }}
                    </h3>

                    <!-- Rating -->
                    <div style="display: flex; align-items: center; margin-bottom: 8px;">
                      <v-rating v-model="item.rating" background-color="#E2E8F0" color="#F59E0B" dense readonly size="16" half-increments></v-rating>
                    </div>

                    <div style="flex-grow: 1;"></div>

                    <!-- Price -->
                    <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 16px;">
                      <div style="font-size: 20px; font-weight: 700; color: #3EA56E;">
                        ₹{{ item.offerPrice || item.price }} 
                        <span v-if="item.unit" style="font-size: 13px; font-weight: 500; color: #64748b;">/ {{ item.unit }}</span>
                      </div>
                      <div v-if="item.price > item.offerPrice" style="font-size: 14px; color: #94a3b8; text-decoration: line-through;">
                        ₹{{ item.price }}
                      </div>
                    </div>

                    <!-- Actions -->
                    <div style="display: flex; gap: 12px; align-items: center; margin-top: auto;">
                      <v-btn 
                        v-if="!item.isincart"
                        depressed 
                        color="#3EA56E" 
                        dark 
                        style="flex: 1; border-radius: 8px; text-transform: none; font-weight: 600; font-size: 14px; height: 40px;"
                        @click.stop="addToCart(item._id)"
                        :disabled="item.status == 'Inactive' || item.quantity < item.minimumOrderQuantity"
                      >
                        <v-icon left size="20">mdi-cart-outline</v-icon>
                        Add to Cart
                      </v-btn>
                      
                      <v-btn 
                        v-if="item.isincart"
                        depressed 
                        color="#3EA56E" 
                        dark 
                        style="flex: 1; border-radius: 8px; text-transform: none; font-weight: 600; font-size: 14px; height: 40px;"
                        @click.stop="$router.push('/cart')"
                      >
                        <v-icon left size="20">mdi-check</v-icon>
                        In Cart
                      </v-btn>

                      <v-btn 
                        icon 
                        outlined 
                        :color="item.inWishlist || item.inwishlist ? '#ef4444' : '#e2e8f0'" 
                        style="border: 1px solid #e2e8f0; border-radius: 8px; width: 40px; height: 40px;"
                        @click.stop="toggleWishlist(item)"
                      >
                        <v-icon size="20" :color="item.inWishlist || item.inwishlist ? '#ef4444' : '#64748b'">{{ item.inWishlist || item.inwishlist ? 'mdi-heart' : 'mdi-heart-outline' }}</v-icon>
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-flex>

      </v-layout>
    </div>
  </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'SellerDetails',
  data() {
    return {
      searchQuery: "",
      appLoading: false,
      sellerData: null,
      mainCategory: [],
      category: [],
      subcategory: [],
      products: [],
      selectedCategoryId: null,
      selectedSubcategoryId: null,
      showSnackBar: false,
      snackbar: false,
      msg: "",
      snackBarColor: "",
      timeout: 3000
    }
  },
  computed: {
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
    filteredSubcategory() {
      if (!this.selectedCategoryId) {
        return [];
      }
      return this.subcategory.filter(sub => {
        if (!sub) return false;
        if (sub.categoryId) {
           if (Array.isArray(sub.categoryId)) {
             return sub.categoryId.some(id => id === this.selectedCategoryId || id._id === this.selectedCategoryId);
           } else {
             return sub.categoryId === this.selectedCategoryId || sub.categoryId._id === this.selectedCategoryId;
           }
        }
        return false;
      });
    }
  },
  watch: {
    searchQuery(newVal) {
      if (!newVal || newVal.trim() === '') {
        this.getProducts();
      }
    }
  },
  methods: {
    setMetaTags() {
      if (!this.sellerData) return;
      const sellerName = this.sellerData.organization ? this.sellerData.organization : (this.sellerData.firstname + (this.sellerData.lastname ? ' ' + this.sellerData.lastname : ''));
      const pageTitle = sellerName + " | KL-06 FARM";
      
      let descText = this.sellerData.seller && this.sellerData.seller.about ? this.sellerData.seller.about : "Shop quality products from " + sellerName + " at KL-06 FARM.";
      if (descText.length > 160) {
        descText = descText.substring(0, 157) + '...';
      }

      document.title = pageTitle;
      let metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', descText);
      } else {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        metaDescription.content = descText;
        document.head.appendChild(metaDescription);
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
    },
    filterByCategory(cat) {
      if (cat) {
        this.selectedCategoryId = cat._id;
        this.selectedSubcategoryId = null; // reset subcategory on category change
      } else {
        this.selectedCategoryId = null;
        this.selectedSubcategoryId = null;
      }
      this.getProducts();
    },
    filterBySubcategory(subcat) {
      if (subcat) {
        this.selectedSubcategoryId = subcat._id;
      } else {
        this.selectedSubcategoryId = null;
      }
      this.getProducts();
    },
    getSellerInfo() {
      this.appLoading = true;
      let param = this.$route.params.id;
      let isObjectId = /^[0-9a-fA-F]{24}$/.test(param);
      
      let params = {
        id: param
      };

      var headers1 = {};
      if (this.appLogin) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      }
      
      axios({
        method: "get",
        url: "/seller/info",
        params: params,
        headers: headers1
      }).then(response => {
        if (response.data.status) {
          this.sellerData = response.data.data;
          this.mainCategory = response.data.mainCategory;
          this.category = response.data.category;
          this.subcategory = response.data.subcategory;
          this.setMetaTags();
          
          if (isObjectId && this.sellerData && this.sellerData.seller && this.sellerData.seller.slug) {
            this.$router.replace('/sellerdetails/' + this.sellerData.seller.slug);
          }
        }
        this.appLoading = false;
      }).catch(err => {
        console.error(err);
        this.appLoading = false;
      });
    },
    getProducts() {
      let param = this.$route.params.id;
      let isObjectId = /^[0-9a-fA-F]{24}$/.test(param);
      
      let data = {
        sellerId: isObjectId ? param : "",
        sellerSlug: isObjectId ? "" : param,
        keyword: this.searchQuery,
      };

      if (this.selectedCategoryId) {
        data.category = this.selectedCategoryId;
      }
      if (this.selectedSubcategoryId) {
        data.subcategory = this.selectedSubcategoryId;
      }

      var headers1 = {};
      if (this.appLogin) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      } else {
        data.guestid = localStorage.getItem("guestId");
      }

      axios({
        method: "post",
        url: "/product/list",
        data: data,
        headers: headers1
      }).then(response => {
        if (response.data.status) {
          this.products = response.data.product || response.data.data || [];
        }
      }).catch(err => {
        console.error(err);
      });
    },
    onSearch() {
      console.log("Searching for: ", this.searchQuery);
      this.getProducts();
    },
    changeRoute(item) {
      localStorage.setItem("productId", item._id);
      this.$router.push("/productdetailview/" + item.urlname);
    },
    addToCart(item) {
       var headers1 = {};
      var data = {
          productId: item,
          quantity: 1,
      };
      if (this.appLogin) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      } else data["guestid"] = localStorage.getItem("guestId");
      axios({
        method: "post",
        url: "/cart/add",
       data: data,
        headers: headers1,
      })
        .then((response) => {
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.snackBarColor = "#3EA56E";
            this.showSnackBar = true;
            this.$store.commit("changeCart", response.data.cartLength);
          } else {
            this.msg = response.data.msg;
            this.snackBarColor = "#FF1313";
            this.showSnackBar = true;
          }
          this.getProducts();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toggleWishlist(item) {
      const inWishlist = item.inWishlist || item.inwishlist;
      const url = inWishlist ? "/WishList/Remove" : "/WishList/Addorupdate";

      var headers1 = {};
      var data = {
        productid: item._id
      };

      if (this.appLogin) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      } else {
        data["guestid"] = localStorage.getItem("guestId");
      }

      axios({
        method: "POST",
        url: url,
        data: data,
        headers: headers1,
      })
      .then((response) => {
        if (response.data.status) {
          this.$set(item, 'inWishlist', !inWishlist);
          this.$set(item, 'inwishlist', !inWishlist);
          this.$store.commit("changeWishlist", response.data.wishlistcount);
          this.msg = response.data.msg;
          this.snackBarColor = "#3EA56E";
          this.showSnackBar = true;
        } else {
          this.msg = response.data.msg;
          this.snackBarColor = "#FF1313";
          this.showSnackBar = true;
        }
      })
      .catch((err) => {
        console.log(err);
      });
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getSellerInfo();
    this.getProducts();
  }
}
</script>

<style scoped>
.modern-card {
  background-color: #ffffff !important;
  border-radius: 20px !important;
  border: 1px solid #f1f5f9 !important;
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.04) !important;
  transition: all 0.3s ease-in-out !important;
}

.avatar-gradient {
  background: linear-gradient(135deg, rgba(62, 165, 110, 0.1) 0%, rgba(62, 165, 110, 0.02) 100%) !important;
  border: 2px solid rgba(62, 165, 110, 0.15) !important;
}

.premium-product-card:hover {
  border-color: rgba(62, 165, 110, 0.3) !important;
  box-shadow: 0 12px 35px -8px rgba(62, 165, 110, 0.15) !important;
  transform: translateY(-4px);
}

.img-shimmer {
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    #e8e8e8 25%,
    #f5f5f5 50%,
    #e8e8e8 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;
  border-radius: 4px;
}

@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.search-input >>> .v-input__slot {
  border-radius: 12px !important;
  min-height: 48px !important;
}
</style>
